class QueryParams {
  values;
  isQueryParams = true;
  constructor(values = null) {
    this.values = values;
  }
}

export { QueryParams as default };
